import styled from "styled-components"
import media from "src/styles/media"
import Img from "gatsby-image"

export const BannerDetalhesWrapper = styled.section`
  height: auto;
  width: 100%;
  padding-top: 80px;

  @media screen and (max-width: 768px) {
    padding-top: 0;
  }
`

export const BannerDetalhesContent = styled.div`
    height: auto;

    ${media.lessThan("xl")`
       padding-top: 0px;
    `} 

    ${media.lessThan("lg")`
        padding-top: 30px;
        text-align: center;
    `} 

    ${media.lessThan("md")`
        padding-top: 25px;
    `} 
`

export const BannerDetalhesCaption = styled.div`
  color: var(--dark);
`

export const BannerDetalhesSubTitle = styled.h2`
  font-size: 22px;
  font-weight: 300;
  opacity: 0.6;
  line-height: 0.8;
  margin-bottom: 7px;
  letter-spacing: 1.5px;

  ${media.lessThan("lg")`
        font-size: 19px;
    `}
`

export const BannerDetalhesTitle = styled.h1`
  font-size: 60px;
  font-weight: 600;
  line-height: 0.8;
  margin-bottom: 20px;
  letter-spacing: -3px;

  span {
    color: var(--primary);
  }

  ${media.lessThan("lg")`
        font-size: 50px;
        margin-bottom: 16px;
    `}

  ${media.lessThan("sm")`
        font-size: 40px;
    `}
`

export const BannerDetalhesDesc = styled.p`
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 1px;
  max-width: 460px;

  ${media.lessThan("lg")`
       max-width: 600px;
       text-align: center;
       margin: 0 auto;
    `}

  ${media.lessThan("md")`
       font-size: 16px;
    `}
`

export const BannerDetalhesHero = styled(Img)`
    margin: 0 auto 0 -10px;
    margin-top: -80px;
    width: 84%;
    animation: float 3s infinite;
    z-index: 4;

    ${media.lessThan("xl")`
        margin-top: -30px;
        width: 90%;
    `} 

    ${media.lessThan("lg")`
        margin: 0 auto 40px auto;
        width: 60%;
    `} 

    ${media.lessThan("md")`
        width: 60%;
    `} 

    ${media.lessThan("sm")`
       margin-top: 20px;
       width: 74%;
    `} 
`
